// @ constants
const {
    GET_PERSONETICS_INSIGHT_DETAILS_FAILURE,
    GET_PERSONETICS_INSIGHT_DETAILS_REQUEST,
    GET_PERSONETICS_INSIGHT_DETAILS_SUCCESS,
} = require('constants/actionTypes');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

const getPersoneticsInsightDetailsRequest = () => ({
    type: GET_PERSONETICS_INSIGHT_DETAILS_REQUEST
});

const getPersoneticsInsightDetailsSuccess = (response, insightId) => ({
    type: GET_PERSONETICS_INSIGHT_DETAILS_SUCCESS,
    payload: {
        response,
        insightId
    }
});

const getPersoneticsInsightDetailsFailure = (error) => ({
    type: GET_PERSONETICS_INSIGHT_DETAILS_FAILURE,
    payload: {
        error
    }
});

const getPersoneticsInsightDetails = (insightId) => (dispatch) => {
    dispatch(getPersoneticsInsightDetailsRequest());
    const params = {
        query: {
            type: 'getInsightDetails',
            protocolVersion: '2.5',
            autoGenerate: true,
            insightId,
            ctxId: 'dashboard',
            lang: getLanguage().toLowerCase()
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'personeticsIntegrationURL',
        params
    })
        .then(response => {
            dispatch(getPersoneticsInsightDetailsSuccess(response, insightId));
        })
       .catch(response => {
            if (!!response.error) {
                dispatch(getPersoneticsInsightDetailsFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getPersoneticsInsightDetails
}